import cms from './cms';

/** Key en data-store: objeto { nombreColor: hex } */
export const DATA_STORE_KEY_VEHICLES_COLORS = 'vehicles_colors';

export type VehiclesColorsMap = Record<string, string>;

/**
 * Obtiene desde data-store el mapa de colores de vehículos (nombre → hex).
 */
export async function fetchVehiclesColors(): Promise<VehiclesColorsMap> {
  try {
    const { data } = await cms.get<VehiclesColorsMap>(
      `/v2/data-store/${DATA_STORE_KEY_VEHICLES_COLORS}`
    );
    return data && typeof data === 'object' ? data : {};
  } catch (error) {
    console.error('Error fetching vehicles colors from data-store:', error);
    return {};
  }
}
